import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"changePaymentState"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`paymentState`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#paymentstate"
          }}>{`PaymentState`}</a>{` - Required`}</li>
      </ul>
      <p parentName="section">{`Changing the Payment State of the Order produces the `}<a parentName="p" {...{
          "href": "/api/../api/projects/messages#order-payment-state-changed"
        }}>{`OrderPaymentStateChanged`}</a>{` Message.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      